document.addEventListener('DOMContentLoaded', function () {
  const isRegistro = window.location.pathname === '/pages/registro';
  const isHome = ['/', '/en', '/fr'].includes(window.location.pathname);

  if (isHome) {
    const modal = document.querySelector('.registerModal');
    if (modal) {
      modal.style.display = 'flex';
      const closeBtn = modal.querySelector('.closeModalBtn');
      if (closeBtn) {
        closeBtn.onclick = function () {
          modal.style.display = 'none';
        };
      }
    }
  } else {
    console.log('Not on home page, modal will not be shown.');
  }
});
